/**
 * The "Edit" action on a change row or a discussion thread - issue #110.
 *
 * Disabled with its reason rather than hidden when the person may not write to
 * the branch: a missing button reads as a broken page. `reason` is the screen's
 * own `useCanWrite` answer, so this agrees with every other control on it.
 */

import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import type { EditTarget } from './elementThreads'

export default function EditElementButton({
  target,
  reason,
  onEdit,
}: {
  target: EditTarget
  /** Why editing is not allowed; empty when it is. */
  reason: string
  onEdit: (target: EditTarget) => void
}) {
  return (
    <Tooltip title={reason || 'Edit this element here'} describeChild>
      {/* A disabled button swallows the pointer events its tooltip needs. */}
      <span>
        <Button
          size="small"
          aria-label={`Edit ${target.label}`}
          disabled={Boolean(reason)}
          onClick={() => onEdit(target)}
          startIcon={<EditOutlinedIcon fontSize="small" />}
          sx={{ minWidth: 0, py: 0 }}
        >
          Edit
        </Button>
      </span>
    </Tooltip>
  )
}
